import _possibleConstructorReturn from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { TransactionVersion, ChainID } from '@stacks/common';
import { createFetchFn } from './fetch';
export var HIRO_MAINNET_DEFAULT = 'https://stacks-node-api.mainnet.stacks.co';
export var HIRO_TESTNET_DEFAULT = 'https://stacks-node-api.testnet.stacks.co';
export var HIRO_MOCKNET_DEFAULT = 'http://localhost:3999';
export var StacksNetworks = ['mainnet', 'testnet'];
export var StacksNetwork =
/*#__PURE__*/
function () {
  function StacksNetwork(networkConfig) {
    var _this = this;

    _classCallCheck(this, StacksNetwork);

    var _a;

    this.version = TransactionVersion.Mainnet;
    this.chainId = ChainID.Mainnet;
    this.bnsLookupUrl = 'https://stacks-node-api.mainnet.stacks.co';
    this.broadcastEndpoint = '/v2/transactions';
    this.transferFeeEstimateEndpoint = '/v2/fees/transfer';
    this.transactionFeeEstimateEndpoint = '/v2/fees/transaction';
    this.accountEndpoint = '/v2/accounts';
    this.contractAbiEndpoint = '/v2/contracts/interface';
    this.readOnlyFunctionCallEndpoint = '/v2/contracts/call-read';

    this.isMainnet = function () {
      return _this.version === TransactionVersion.Mainnet;
    };

    this.getBroadcastApiUrl = function () {
      return "".concat(_this.coreApiUrl).concat(_this.broadcastEndpoint);
    };

    this.getTransferFeeEstimateApiUrl = function () {
      return "".concat(_this.coreApiUrl).concat(_this.transferFeeEstimateEndpoint);
    };

    this.getTransactionFeeEstimateApiUrl = function () {
      return "".concat(_this.coreApiUrl).concat(_this.transactionFeeEstimateEndpoint);
    };

    this.getAccountApiUrl = function (address) {
      return "".concat(_this.coreApiUrl).concat(_this.accountEndpoint, "/").concat(address, "?proof=0");
    };

    this.getAbiApiUrl = function (address, contract) {
      return "".concat(_this.coreApiUrl).concat(_this.contractAbiEndpoint, "/").concat(address, "/").concat(contract);
    };

    this.getReadOnlyFunctionCallApiUrl = function (contractAddress, contractName, functionName) {
      return "".concat(_this.coreApiUrl).concat(_this.readOnlyFunctionCallEndpoint, "/").concat(contractAddress, "/").concat(contractName, "/").concat(encodeURIComponent(functionName));
    };

    this.getInfoUrl = function () {
      return "".concat(_this.coreApiUrl, "/v2/info");
    };

    this.getBlockTimeInfoUrl = function () {
      return "".concat(_this.coreApiUrl, "/extended/v1/info/network_block_times");
    };

    this.getPoxInfoUrl = function () {
      return "".concat(_this.coreApiUrl, "/v2/pox");
    };

    this.getRewardsUrl = function (address, options) {
      var url = "".concat(_this.coreApiUrl, "/extended/v1/burnchain/rewards/").concat(address);

      if (options) {
        url = "".concat(url, "?limit=").concat(options.limit, "&offset=").concat(options.offset);
      }

      return url;
    };

    this.getRewardsTotalUrl = function (address) {
      return "".concat(_this.coreApiUrl, "/extended/v1/burnchain/rewards/").concat(address, "/total");
    };

    this.getRewardHoldersUrl = function (address, options) {
      var url = "".concat(_this.coreApiUrl, "/extended/v1/burnchain/reward_slot_holders/").concat(address);

      if (options) {
        url = "".concat(url, "?limit=").concat(options.limit, "&offset=").concat(options.offset);
      }

      return url;
    };

    this.getStackerInfoUrl = function (contractAddress, contractName) {
      return "".concat(_this.coreApiUrl).concat(_this.readOnlyFunctionCallEndpoint, "\n    ").concat(contractAddress, "/").concat(contractName, "/get-stacker-info");
    };

    this.coreApiUrl = networkConfig.url;
    this.fetchFn = (_a = networkConfig.fetchFn) !== null && _a !== void 0 ? _a : createFetchFn();
  }

  _createClass(StacksNetwork, [{
    key: "getNameInfo",
    value: function getNameInfo(fullyQualifiedName) {
      var nameLookupURL = "".concat(this.bnsLookupUrl, "/v1/names/").concat(fullyQualifiedName);
      return this.fetchFn(nameLookupURL).then(function (resp) {
        if (resp.status === 404) {
          throw new Error('Name not found');
        } else if (resp.status !== 200) {
          throw new Error("Bad response status: ".concat(resp.status));
        } else {
          return resp.json();
        }
      }).then(function (nameInfo) {
        if (nameInfo.address) {
          return Object.assign({}, nameInfo, {
            address: nameInfo.address
          });
        } else {
          return nameInfo;
        }
      });
    }
  }]);

  return StacksNetwork;
}();

StacksNetwork.fromName = function (networkName) {
  switch (networkName) {
    case 'mainnet':
      return new StacksMainnet();

    case 'testnet':
      return new StacksTestnet();

    default:
      throw new Error("Invalid network name provided. Must be one of the following: ".concat(StacksNetworks.join(', ')));
  }
};

StacksNetwork.fromNameOrNetwork = function (network) {
  if (typeof network !== 'string' && 'version' in network) {
    return network;
  }

  return StacksNetwork.fromName(network);
};

export var StacksMainnet =
/*#__PURE__*/
function (_StacksNetwork) {
  _inherits(StacksMainnet, _StacksNetwork);

  function StacksMainnet(opts) {
    var _this2;

    _classCallCheck(this, StacksMainnet);

    var _a;

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(StacksMainnet).call(this, {
      url: (_a = opts === null || opts === void 0 ? void 0 : opts.url) !== null && _a !== void 0 ? _a : HIRO_MAINNET_DEFAULT,
      fetchFn: opts === null || opts === void 0 ? void 0 : opts.fetchFn
    }));
    _this2.version = TransactionVersion.Mainnet;
    _this2.chainId = ChainID.Mainnet;
    return _this2;
  }

  return StacksMainnet;
}(StacksNetwork);
export var StacksTestnet =
/*#__PURE__*/
function (_StacksNetwork2) {
  _inherits(StacksTestnet, _StacksNetwork2);

  function StacksTestnet(opts) {
    var _this3;

    _classCallCheck(this, StacksTestnet);

    var _a;

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(StacksTestnet).call(this, {
      url: (_a = opts === null || opts === void 0 ? void 0 : opts.url) !== null && _a !== void 0 ? _a : HIRO_TESTNET_DEFAULT,
      fetchFn: opts === null || opts === void 0 ? void 0 : opts.fetchFn
    }));
    _this3.version = TransactionVersion.Testnet;
    _this3.chainId = ChainID.Testnet;
    return _this3;
  }

  return StacksTestnet;
}(StacksNetwork);
export var StacksMocknet =
/*#__PURE__*/
function (_StacksNetwork3) {
  _inherits(StacksMocknet, _StacksNetwork3);

  function StacksMocknet(opts) {
    var _this4;

    _classCallCheck(this, StacksMocknet);

    var _a;

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(StacksMocknet).call(this, {
      url: (_a = opts === null || opts === void 0 ? void 0 : opts.url) !== null && _a !== void 0 ? _a : HIRO_MOCKNET_DEFAULT,
      fetchFn: opts === null || opts === void 0 ? void 0 : opts.fetchFn
    }));
    _this4.version = TransactionVersion.Testnet;
    _this4.chainId = ChainID.Testnet;
    return _this4;
  }

  return StacksMocknet;
}(StacksNetwork);